export default __webpack_public_path__ + "static/210526_妲絲刷關活動熱更完成_tc-5860930abce9a4c42eba89b2202efcb8.webp";